/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync>): BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync(), model);
        BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync>): BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.newInstance(<BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicThreatsVulnerabilityGraphDBSummarySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
